import type { Exhibit, Region } from '../shared/types'

export interface RegionDefinition {
  id: Region
  title: string
  subtitle: string
  color: string
}

/** Region order and action families follow MuseumBehaviorTable.ValidAction. */
export const REGIONS: readonly RegionDefinition[] = [
  { id: 1, title: '影像采样', subtitle: '停留，观看手掌构成的羽翼', color: '#ef9c61' },
  { id: 2, title: '态度采样', subtitle: '一段关于工作与休息的争论', color: '#88b5aa' },
  { id: 3, title: '留言采样', subtitle: '为这段人类记忆留下一句话', color: '#92a5d6' },
  { id: 4, title: '传播采样', subtitle: '你会如何让一件作品被看见？', color: '#d38fa5' },
]

/**
 * Stable IDs for four interaction families. Physical targets are loaded from
 * the original Unity scene, where each family has several anchors. These
 * demo responses do not represent the full behavioral workbook.
 */
export const EXHIBITS: readonly Exhibit[] = [
  {
    id: 'echo-window',
    region: 1,
    title: '影像采样 · 手掌构成的羽翼',
    description: '停留，观看手掌构成的羽翼。展品影像来自 HumanMuseum 参考项目的本地演示资源。',
    position: [-8, 0, -5],
    color: REGIONS[0].color,
    actions: ['browse', 'play'],
    sourceRowId: 'demo-r1-01',
    termIds: ['demo-term:video', 'demo-term:attention'],
    visualTerms: ['手掌构成的羽翼', '影像采样'],
    actionPolicy: 'once',
  },
  {
    id: 'open-question',
    region: 2,
    title: '态度采样 · 工作与休息',
    description: '公司团建，算不算上班？选择“赞同”“反对”或“忽略”，回应只作为本地参观记录。',
    position: [8, 0, -5],
    color: REGIONS[1].color,
    actions: ['browse', 'agree', 'oppose', 'ignore'],
    sourceRowId: 'demo-r2-01',
    termIds: ['demo-term:work-rest'],
    visualTerms: ['公司团建', '工作与休息'],
    actionPolicy: 'once',
  },
  {
    id: 'listening-wall',
    region: 3,
    title: '留言采样 · 人类记忆',
    description: '为这段人类记忆留下一句话。你的留言保存在本地参观档案。',
    position: [-8, 0, -17],
    color: REGIONS[2].color,
    actions: ['browse', 'comment'],
    sourceRowId: 'demo-r3-01',
    termIds: ['demo-term:memory-message'],
    visualTerms: ['人类记忆', '留言采样'],
    actionPolicy: 'repeat',
  },
  {
    id: 'message-current',
    region: 4,
    title: '传播采样 · 让作品被看见',
    description: '你会怎样分享这件作品？转发、推荐或标记仅记录在本地，不会发布到外部平台。',
    position: [8, 0, -17],
    color: REGIONS[3].color,
    actions: ['browse', 'share', 'grow', 'report'],
    sourceRowId: 'demo-r4-01',
    termIds: ['demo-term:sharing'],
    visualTerms: ['让作品被看见', '传播采样'],
    actionPolicy: 'once',
  },
]

export const DURATION_MS = 90_000
export const SCENE_VERSION = 'humanmuseum-unity-source-scene-v3'
export const MAPPING_VERSION = 'humanmuseum-demo-v2'

const exhibitsById = new Map(EXHIBITS.map((exhibit) => [exhibit.id, exhibit]))

export function getExhibit(id: string): Exhibit | undefined {
  return exhibitsById.get(id)
}
